<div class="container">
  <div class="alert alert-danger w-auto">
    {{ errorKey | localize }}
  </div>
</div>
